<template>
  <td :id="randomId" :class="twMerge('min-w-2 max-sm:px-3 md:p-1 max-md:first:text-left max-md:last:text-right max-md:text-center',props.appendClass)">
    <slot name="body"></slot>
  </td>
</template>
<script setup lang="ts">
import {twMerge} from "tailwind-merge"
import {onMounted, ref} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
 type Props={
   appendClass:string
 }
 const props= defineProps<Props>()
const randomId  = ref<string>("");

const model = defineModel()

onMounted(() => {
  randomId.value = useRandomUUID();
});
</script>
